export const ViewportSettings = {
    MobileMax: 767,
    TabletMax: 992
}

const getViewportWidth = () => {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
}

export const isMobileViewport = () => {
    return getViewportWidth() <= ViewportSettings.MobileMax;
}

export const isTabletViewport = () => {
    return getViewportWidth() <= ViewportSettings.TabletMax;
}